import { IParameter } from "./parameter";
import { IAnimal } from "./animals";
import { IUniqueId } from "./_uniqueId";


enum StateOfReform {
    StandBy = "StandBy",
    Validate = "Validate",
    Refuse = "Refuse"
}

interface IReform extends IUniqueId {
  animalId: number;
  animal: IAnimal;
  typeReform: IParameter;
  reason: IParameter;
  state: StateOfReform;
  dateReform: Date;
  observations?: string;
  lastGenerationDate?: Date;
}


export { type IReform, StateOfReform };